import { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge, EmptyState } from '../ui';
import { MissionCard } from '../etch/MissionCard';
import { deriveMissionStatus } from '../../context/MissionContext';

/**
 * One band of the Mission Center: heading, count, and either the cards or the
 * section's own empty state (spec §10.3 — "Empty states per section", because a
 * single global "nothing here" hides which of the three bands is actually
 * empty).
 */
export function MissionSection({
  title,
  description,
  missions,
  dueIds,
  draftIds,
  emptyTitle,
  emptyBody,
  emptyAction,
  onStart,
}) {
  const { t } = useTranslation();
  const headingId = useId();

  return (
    <section className="etch-mission-section" aria-labelledby={headingId}>
      <div className="etch-mission-section__head">
        <h2 id={headingId} className="etch-mission-section__title">
          {title}
        </h2>
        <Badge>{t('missions.countLabel', { count: missions.length })}</Badge>
      </div>
      {description && <p className="etch-mission-section__description">{description}</p>}

      {missions.length === 0 ? (
        <EmptyState title={emptyTitle} action={emptyAction}>
          {emptyBody}
        </EmptyState>
      ) : (
        <ul className="etch-mission-section__list">
          {missions.map((mission) => (
            <li key={mission.id}>
              <MissionCard
                mission={mission}
                status={deriveMissionStatus(mission, {
                  due: dueIds.has(mission.id),
                  hasDraft: draftIds.has(mission.id),
                })}
                onStart={() => onStart(mission)}
              />
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}

export default MissionSection;
